/**
 * Declaration of external URL used in the webapp.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025
 */

export const EXTERNAL_URLS = {
  CONTACT: 'https://www.ircamamplify.com/contact',
} as const
